<template>
	<sk-tertiary-btn :text="$t('commons.cta.cancel')" />
</template>

<style scoped lang="scss"></style>

<script setup lang="ts">
import { SkTertiaryBtn } from '@silae/components/buttons';
</script>
